import { Union } from 'ts-toolbelt';

import { Gender, UpdateHealthBasicsInput } from 'types/graph';

import { HealthBasicsFormValues } from '../form/types';

const orFalse = (bool: Union.Nullable<boolean>): boolean => bool ?? false;

const buildInput = (
  values: HealthBasicsFormValues,
  gender: Union.Nullable<Gender>
): UpdateHealthBasicsInput => {
  const input: UpdateHealthBasicsInput = {
    heightInInches: values.heightInInches,
    weight: values.weight,
    historyOfTobaccoUse: values.historyOfTobaccoUse,
    suspendedConviction: values.suspendedConviction,
    dwiConviction: values.dwiConviction,
    asthma: orFalse(values.asthma),
    backProblems: orFalse(values.backProblems),
    basalCellSkinCancer: orFalse(values.basalCellSkinCancer),
    cancer: orFalse(values.cancer),
    carpalTunnel: orFalse(values.carpalTunnel),
    copd: orFalse(values.copd),
    depression: orFalse(values.depression),
    diabetes: orFalse(values.diabetes),
    emphysema: orFalse(values.emphysema),
    epilepsy: orFalse(values.epilepsy),
    glaucoma: orFalse(values.glaucoma),
    headachesOrMigraines: orFalse(values.headachesOrMigraines),
    heartDisease: orFalse(values.heartDisease),
    highBloodPressure: orFalse(values.highBloodPressure),
    highCholesterol: orFalse(values.highCholesterol),
    kidneyOrLiverDisease: orFalse(values.kidneyOrLiverDisease),
    kneeInjuryOrSurgery: orFalse(values.kneeInjuryOrSurgery),
    mentalIllness: orFalse(values.mentalIllness),
    otherSeriousMedicalConditions: orFalse(values.otherSeriousMedicalConditions),
    rheumatoidArthritis: orFalse(values.rheumatoidArthritis),
    sleepApnea: orFalse(values.sleepApnea),
    stroke: orFalse(values.stroke),
    ulcerativeColitisOrIleitis: orFalse(values.ulcerativeColitisOrIleitis),
    vascularDisease: orFalse(values.vascularDisease),
    multipleSclerosis: orFalse(values.multipleSclerosis),
    alzheimerDisease: orFalse(values.alzheimerDisease),
    otherHealthIssues: values.otherHealthIssues ?? '',
  };

  if (gender === Gender.Female) {
    input.planningToBeOrPregnant = values.planningToBeOrPregnant;
  }

  if (values.historyOfTobaccoUse) {
    input.usedInPastYear = values.usedInPastYear;
  }

  return input;
};

export default buildInput;
